import React from 'react';
import { Button } from 'antd';

/**
 * A button that looks like a link but maintains button behavior.
 * Useful for actions that should look like links but need button functionality.
 * 
 * @param {Object} props
 * @param {React.ReactNode} props.children - The content of the button
 * @param {Function} props.onClick - Click handler function
 * @param {string} [props.color] - Custom color for the link (defaults to main color)
 * @param {Object} [props.style] - Additional styles to apply
 * @param {Object} [props.buttonProps] - Additional props to pass to the Button component
 */
const LinkButton = ({ 
  children, 
  onClick, 
  color = 'var(--main-color)', 
  style = {}, 
  buttonProps = {} 
}) => {
  return (
    <Button
      type="link"
      style={{ 
        color,
        cursor: 'pointer',
        padding: 0,
        height: 'auto',
        textAlign: 'left',
        ...style
      }}
      onClick={onClick}
      {...buttonProps}
    >
      {children}
    </Button>
  );
};

export default LinkButton; 